module.exports = __webpack_public_path__ + "img/usmin.b9158e5c.png";